<template>
    <v-multiselect
      v-model="selected"
      :options="terms"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      track-by="value"
      label="label"
      multiple
      placeholder=""
      @search-change="onSearch"
      @open="onOpen"
      >
      <template slot="option" slot-scope="props">
        <div class="d-flex align-items-center justify-content-between">
          <span class="mr-2">{{ props.option.label }}</span>
          <small class="filter-bucket-size font-weight-bold">{{ props.option.count }}</small>
        </div>
      </template>
      <template slot="beforeList">
        <div v-if="charactersRemainder > 0">
          Пожалуйста, введите еще хотя бы {{charactersRemainder}} символ
        </div>
      </template>
    </v-multiselect>
</template>

<script>
  import {assign, map, debounce} from 'lodash'
  import FilterTerms from './filter-terms.vue'
  import api from '@/api'

  export default {
    name: 'FilterSearch',
    extends: FilterTerms,
    props: {
      name: {type: String},
      filters: {type: Object},
      endpoint: {type: String},
      minimum_input_length: {type: Number},
    },
    data () {
      return {
        isLoading: false,
        firstOpen: true,
        termLength: 0,
      }
    },
    computed: {
      debouncedSearch () {
        return debounce(this.search, this.debounceDelay)
      },
      charactersRemainder () {
        return (this.minimum_input_length || 0) - this.termLength
      },
    },
    methods: {
      onSearch (term) {
        this.isLoading = true
        this.debouncedSearch(term)
      },
      search (term) {
        this.termLength = term.length
        if (this.termLength < (this.minimum_input_length || 0)) {
          this.isLoading = false
          this.options = []
          return
        }

        this.isLoading = true
        const params = {
          filters: assign({}, this.filters, {
            _search: {
              term: term,
              name: this.name,
            },
          }),
        }
        api
          .get(this.endpoint, {params})
          .then(({data}) => {
            this.options = data.filters
            this.isLoading = false
          })
      },
      onOpen () {
        if (this.firstOpen) {
          if ((this.minimum_input_length || 0) === 0) {
            this.onSearch('')
          }
          this.firstOpen = false
        }
      },
    },
    watch: {
      options (newOptions) {
        this.terms = newOptions
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-search.vue